import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import {
  haalAandacht, haalCharging, haalLive, haalMijlpalen, haalMijnTaken, haalProjecten, haalRecent, rondTaakAf,
  type DashboardClient,
} from './data/dashboard';

const client = supabase as unknown as DashboardClient;
const d = (...k: unknown[]) => ['dashboard', ...k];

export const useAandacht = (userId: string | undefined) =>
  useQuery({ queryKey: d('aandacht', userId), queryFn: () => haalAandacht(client, userId!), enabled: Boolean(userId), staleTime: 60_000 });

export const useDashboardProjecten = () => useQuery({ queryKey: d('projecten'), queryFn: () => haalProjecten(client), staleTime: 60_000 });

export const useMijnTaken = (userId: string | undefined) =>
  useQuery({ queryKey: d('taken', userId), queryFn: () => haalMijnTaken(client, userId!), enabled: Boolean(userId) });

export const useMijlpalen = () => useQuery({ queryKey: d('mijlpalen'), queryFn: () => haalMijlpalen(client) });

export const useRecent = () => useQuery({ queryKey: d('recent'), queryFn: () => haalRecent(client), staleTime: 60_000 });

export const useLive = () =>
  useQuery({ queryKey: d('live'), queryFn: () => haalLive(client), staleTime: 60_000, refetchInterval: 5 * 60_000, refetchOnWindowFocus: false });

export const useCharging = () => useQuery({ queryKey: d('charging'), queryFn: () => haalCharging(client), staleTime: 5 * 60_000 });

export function useRondTaakAf() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => rondTaakAf(client, id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: d('taken') });
      qc.invalidateQueries({ queryKey: d('aandacht') });
    },
  });
}
